import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationService } from '../sm-base/services/authentication.service';
import { EditCalendarEventTemplateComponent } from './components/edit-calendar-event-template/edit-calendar-event-template.component';
import { EditCalendarEventTemplatesComponent } from './components/edit-calendar-event-templates/edit-calendar-event-templates.component';
import { EditCalendarEventTypeComponent } from './components/edit-calendar-event-type/edit-calendar-event-type.component';
import { EditCalendarEventTypesComponent } from './components/edit-calendar-event-types/edit-calendar-event-types';
import { EditCalendarOutlineLevelComponent } from './components/edit-calendar-outline-level/edit-calendar-outline-level.component';
import { EditCalendarOutlineLevelsComponent } from './components/edit-calendar-outline-levels/edit-calendar-outline-levels';
import { EditCalendarOutlineTemplateComponent } from './components/edit-calendar-outline-template/edit-calendar-outline-template.component';
import { EditCalendarOutlineTemplatesComponent } from './components/edit-calendar-outline-templates/edit-calendar-outline-templates.component';
import { EditCalendarRoleComponent } from './components/edit-calendar-role/edit-calendar-role.component';
import { EditCalendarRolesComponent } from './components/edit-calendar-roles/edit-calendar-roles.component';
import { EditNetworkLinkedDocumentCategoryComponent } from './components/edit-network-linked-document-category/edit-network-linked-document-category.component';
import { EditNetworkLinkedDocumentCategoriesComponent } from './components/edit-network-linked-document-categories/edit-network-linked-document-categories';
import { EditProjectCustomFieldDefinitionComponent } from './components/edit-project-custom-field-definition/edit-project-custom-field-definition.component';
import { EditProjectCustomFieldDefinitionsComponent } from './components/edit-project-custom-field-definitions/edit-project-custom-field-definitions.component';
import { EditProjectTemplateComponent } from './components/edit-project-template/edit-project-template.component';
import { EditProjectTemplatesComponent } from './components/edit-project-templates/edit-project-templates.component';
import { EditProjectTypeComponent } from './components/edit-project-type/edit-project-type.component';
import { EditProjectTypesComponent } from './components/edit-project-types/edit-project-types';
import { EditProjectComponent } from './components/edit-project/edit-project.component';
import { EditProjectsComponent } from './components/edit-projects/edit-projects.component';
import { EditResourceTypeComponent } from './components/edit-resource-type/edit-resource-type.component';
import { EditResourceTypesComponent } from './components/edit-resource-types/edit-resource-types';
import { EditResourceComponent } from './components/edit-resource/edit-resource.component';
import { EditResourcesComponent } from './components/edit-resources/edit-resources.component';
import { ProjectPlanningMainComponent } from './components/project-planning-main/project-planning-main.component';

const routes: Routes = [
    {
        path: 'home',
        component: ProjectPlanningMainComponent
    },
    {
        path: "admin/edit-calendar-event-types",
        component: EditCalendarEventTypesComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-calendar-event-type/:id",
        component: EditCalendarEventTypeComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-calendar-event-templates",
        component: EditCalendarEventTemplatesComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-calendar-event-template/:id",
        component: EditCalendarEventTemplateComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-calendar-roles",
        component: EditCalendarRolesComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-calendar-role/:id",
        component: EditCalendarRoleComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-calendar-outline-levels",
        component: EditCalendarOutlineLevelsComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-calendar-outline-level/:id",
        component: EditCalendarOutlineLevelComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-calendar-outline-templates",
        component: EditCalendarOutlineTemplatesComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-calendar-outline-template/:id",
        component: EditCalendarOutlineTemplateComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-project-custom-field-definitions",
        component: EditProjectCustomFieldDefinitionsComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-project-custom-field-definition/:id",
        component: EditProjectCustomFieldDefinitionComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-project-types",
        component: EditProjectTypesComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-project-type/:id",
        component: EditProjectTypeComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-project-templates",
        component: EditProjectTemplatesComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-project-template/:id",
        component: EditProjectTemplateComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-projects",
        component: EditProjectsComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-project/:id",
        component: EditProjectComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-project-custom-field-definitions",
        component: EditProjectCustomFieldDefinitionsComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-project-custom-field-definition/:id",
        component: EditProjectCustomFieldDefinitionComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-resource-types",
        component: EditResourceTypesComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-resource-type/:id",
        component: EditResourceTypeComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-network-linked-document-categories",
        component: EditNetworkLinkedDocumentCategoriesComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-network-linked-document-category/:id",
        component: EditNetworkLinkedDocumentCategoryComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-resources",
        component: EditResourcesComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: "admin/edit-resource/:id",
        component: EditResourceComponent,
        canActivate: [() => inject(AuthenticationService).userDetails.getDatabaseUser().isAdmin]
    },
    {
        path: '',
        redirectTo: "home",
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ProjectPlanningRoutingModule {
}
